import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom"
import { Login } from "@/pages/login"
import { ResetPassword } from "@/pages/reset-password"
import { AppLayout } from "@/components/app-layout"
import { Toaster } from "@/components/ui/toaster"
import { useEffect, useRef } from "react"
import { PermissionsProvider } from "./lib/hooks/usePermissions"

function PasswordRecoveryRedirect() {
  const navigate = useNavigate()
  const hashProcessedRef = useRef(false)

  useEffect(() => {
    if (hashProcessedRef.current) return

    const hash = window.location.hash
    if (hash) {
      const hashParams = new URLSearchParams(hash.substring(1))
      const type = hashParams.get('type')
      const currentPath = window.location.pathname
      if (type === 'recovery' && currentPath !== '/reset-password') {
        hashProcessedRef.current = true
        navigate(`/reset-password${hash}`, { replace: true })
      } else {
        hashProcessedRef.current = true
      }
    } else {
      hashProcessedRef.current = true
    }
  }, [navigate])

  return null
}

export default function App() {
  return (
    <Router>
      <PasswordRecoveryRedirect />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/*" element={<PermissionsProvider><AppLayout /></PermissionsProvider>} />
      </Routes>
      <Toaster />
    </Router>
  )
}

